import { render, staticRenderFns } from "./superad_shipmentreport.vue?vue&type=template&id=229774f2&"
import script from "./superad_shipmentreport.vue?vue&type=script&lang=js&"
export * from "./superad_shipmentreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports